type PropTypes = {
  className?: string
}

const ReportIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      className={className}
    >
      <path
        fill="#fff"
        fillOpacity=".01"
        d="M0 0h16v16H0z"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path fill="currentColor" d="m12.85 4.65-3.5-3.5C9.25 1.05 9.15 1 9 1H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.15-.05-.25-.15-.35ZM9 2.2 11.8 5H9V2.2ZM12 14H4V2h4v3c0 .55.45 1 1 1h3v8Z" />
      <path fill="currentColor" d="M11 11H5v1h6v-1ZM11 8H5v1h6V8Z" />
    </svg>
  )
}

export default ReportIcon
